"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const immer_1 = __importDefault(require("immer"));
const typesafe_actions_1 = require("typesafe-actions");
const Widget_1 = require("~/components/UI/Widget");
const actionCreators = __importStar(require("./actions"));
const consts_1 = require("./consts");
const defaultWidgetState = {
    show: false,
    size: {
        width: Widget_1.widgetMinWidth,
        height: Widget_1.widgetMinHeight,
    },
    position: {
        x: 0,
        y: 0,
    },
    restored: false,
};
const initialState = {
    activeWidgetsHistory: [],
    widgets: Object.values(consts_1.WIDGETS).reduce((acc, curr) => (Object.assign(Object.assign({}, acc), { [curr]: defaultWidgetState })), {}),
};
// eslint-disable-next-line default-param-last
const reducer = (state = initialState, action) => (0, immer_1.default)(state, (draft) => {
    switch (action.type) {
        case (0, typesafe_actions_1.getType)(actionCreators.initPersistentWidgets): {
            Object.values(consts_1.PERSISTENT_WIDGETS).forEach((widgetName) => {
                const savedData = localStorage.getItem(`${widgetName}-shape`);
                if (savedData) {
                    const saved = JSON.parse(savedData);
                    draft.widgets[widgetName].position = saved.position;
                    draft.widgets[widgetName].size = saved.size;
                    draft.widgets[widgetName].restored = true;
                }
            });
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.toggleWidget): {
            draft.widgets[action.payload.widgetName].show = action.payload.show;
            // remove widget and add on top if activated
            draft.activeWidgetsHistory = draft.activeWidgetsHistory.filter((widgetName) => widgetName !== action.payload.widgetName);
            if (action.payload.show) {
                draft.activeWidgetsHistory = [...draft.activeWidgetsHistory, action.payload.widgetName];
            }
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.liftUpWidget): {
            draft.activeWidgetsHistory = [
                ...draft.activeWidgetsHistory.filter((widgetName) => widgetName !== action.payload),
                action.payload,
            ];
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.updateWidgetSize): {
            draft.widgets[action.payload.widgetName].size = action.payload.size;
            return;
        }
        case (0, typesafe_actions_1.getType)(actionCreators.updateWidgetPosition): {
            draft.widgets[action.payload.widgetName].position = action.payload.position;
            // eslint-disable-next-line no-useless-return
            return;
        }
        default: {
            // eslint-disable-next-line no-useless-return
            return;
        }
    }
});
exports.default = reducer;
